import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Session from 'supertokens-auth-react/recipe/session';
import RoutePaths from '../../router/RoutePaths';

export default function BasePublicLayout(): JSX.Element {
  const navigate = useNavigate();
  useEffect(() => {
    const checkSession = async () => {
      try {
        const isSessionActive = await Session.doesSessionExist();
        if (isSessionActive) {
          navigate(RoutePaths.Home);
        }
      } catch (error) {
        console.error('Error checking session:', error);
      }
    };

    checkSession();
  }, []);

  return (
    <div>
      <Outlet />
    </div>
  );
}
